import React, {useState, useEffect} from "react";
import { Link } from "react-router";
import { GeneralButton, TextInput } from '../../../../common/inputs';
import useApi from "../../../../../hooks/useApi";
import externalApiService from "../../../../../services/externalApiService";
import { toast } from "react-toastify";
import { RadioImageButton } from '../../../../common/inputs/radioButton/radioButton';
import myob from "../../../../../img/icons/myob_logo.png";
import LoadingSpinner from "../../../../common/loaders/loadingSpinner";
import Connect from "../../../../../img/icons/FMB_icon6.svg";

export default function PendingCard({
  connectedAccSw,
  onConfirm,
  fetchConnectionStatus,
  entityDetails,
  onCancel
}) {
    
    const [myobFileName, setMyobFileName] = useState("");
    const [companyList, setCompanyList] = useState([]);
    const [showManualInput, setShowManualInput] = useState(false);

    const myobCompanyFileApi = useApi(externalApiService.GetMyobCompanyFile);
    const myobAllCompanyFileApi = useApi(externalApiService.GetMyobAllCompanyFile);

    const myobGetCompanyFiles = async () => {
        const { data } = await myobCompanyFileApi.request({
            entityId: entityDetails.a_guid,
            fileName: myobFileName,
        });
        if (data.success) {
            toast.success(data.message);
            setMyobFileName("");
            fetchConnectionStatus();
        } else {
            toast.error(data.message);
        }
    };

    const getAllCompanyFiles = async () => {
        const response = await myobAllCompanyFileApi.request({
            entityId: entityDetails.a_guid,
        });
        if (response.data.success) {
            setCompanyList(response.data.data)
        } else {
            toast.error(response.data.message);
        }
    }

    useEffect(() => {
        if(connectedAccSw == 'Myob'){
            getAllCompanyFiles();
        }     
    },[]);


  return (
    <>
        <div className="card">
            <div className="card-body">
                { connectedAccSw === "Myob" ? (
                    <>
                        <div className="d-flex justify-content-between align-items-start mb-3">
                            <h6 className="fw-bold mb-0">Connect to {connectedAccSw}</h6>
                        </div>
                        {myobAllCompanyFileApi.loading ? (<LoadingSpinner normal="true" />) : (
                            <>
                            <div className="mb-3">
                                <h6 className="h6 mb-1">Select Your Company File</h6>
                                <p className="text-muted mb-0">Choose the company file you want to connect</p>
                            </div>
                            <div className="mb-3">
                                {
                                    companyList && companyList.length > 0 ? (
                                        <div className="overflow-auto" style={{ maxHeight: "28rem" }}>
                                            <form aria-label="MYOB company selection">
                                                <div className="d-grid gap-3">
                                                    {companyList.map((company) => (
                                                        <RadioImageButton
                                                            key={company.Id}
                                                            name="acc_sw_type"
                                                            value={company.Name}
                                                            id={company.Id}
                                                            imgsrc={myob}
                                                            label={company.Name}
                                                            onChange={() => setMyobFileName(company.Name)}
                                                            checked={myobFileName === company.Name}
                                                        />
                                                    ))}
                                                </div>
                                            </form>
                                        </div>
                                    ) : (
                                        <div className="text-center py-5 border rounded-3">
                                            <img src={myob} alt="MYOB" style={{ width: 64, height: 64, opacity: 0.75 }} />
                                            <p className="mt-3 mb-1 fw-medium">No company files found</p>
                                            <p className="small text-muted">Enter the company name manually.</p>
                                        </div>
                                    )
                                }
                            </div>
                
                            {showManualInput && (
                                <div className="card mb-3">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <label className="form-label fw-semibold mb-0">Enter Company Name Manually</label>
                                            <GeneralButton
                                                className="btn btn-light ml-3"
                                                onClick={() => {
                                                    setShowManualInput(false);
                                                    setMyobFileName("");
                                                }}
                                                name="Cancel"
                                            />
                                        </div>
                                        <TextInput
                                            name="myobFileName"
                                            value={myobFileName}
                                            onChange={(e) => setMyobFileName(e.target.value)}
                                            type="normal"
                                            placeholder="Enter your company name exactly as in MYOB"
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="d-flex gap-2 justify-content-between">
                                <div className="mb-3">
                                    {
                                        !showManualInput && (
                                            <a
                                                type="button"
                                                className="w-100 d-flex align-items-center justify-content-center"
                                                onClick={() => setShowManualInput(true)}
                                            >
                                                + Can't find your company file? Enter manually
                                            </a>
                                          ) 
                                    }
                                </div>
                                <div>
                                    <GeneralButton
                                        type="button"
                                        onClick={onCancel}
                                        className="btn btn-sm btn-outline-secondary"
                                        name="Start Over"
                                    />
                                    <GeneralButton
                                        type="button"
                                        onClick={myobGetCompanyFiles}
                                        className="btn btn-sm btn-primary ml-2"
                                        name="Connect Company File"
                                        disabled={!myobFileName}
                                    />
                                </div>
                            </div>
                        </>
                        )
                    }
                    </>
                ) : (
                    <>
                        <div className="d-flex align-items-start mb-3">
                            <h6 className="fw-bold mb-0">Connect to {connectedAccSw}</h6>
                        </div>
                        <div className="text-center">
                            <img height={"400px"} src={Connect} className="" />
                            <div className="mb-3">
                                <h6 className="h6 mb-1 text-danger">We couldn’t complete authentication.</h6>
                                <p className="mb-0">This usually happens because of expired sign-in session, or network issue.</p>
                            </div>
                            <GeneralButton
                                type="button"
                                onClick={onCancel}
                                className="btn btn-sm btn-outline-secondary"
                                name="Start Over"
                            />
                            { connectedAccSw === "Xero" && (
                                <Link onClick={onConfirm}>
                                    <GeneralButton className="btn btn-sm btn-primary ml-3" name="Retry Connection" />
                                </Link>
                            )}
                        </div>
                    </>
                )}
            </div>    
        </div>
    </>
  );
}
